import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PaginatedService } from '../model/pagination/paginated-service.model';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '../model/pagination/paginated-response.model';
import { HttpOptions } from '../model/http-options.model';
import { map } from 'rxjs/operators';
import { Story } from '../model/story/story.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StoryService implements PaginatedService<Story> {
  private httpClient = inject(HttpClient);

  public getPaginatedList(options?: HttpOptions): Observable<PaginatedResponse<Story>> {
    return this.httpClient.get(
      `${environment.apiUrl}/api/stories`,
      options,
    ).pipe(
      map((response: any): PaginatedResponse<Story> => {
        const items: Story[] = response.items
          .map((response: any): Story => Story.createFromApi(response));
        return new PaginatedResponse<Story>({
          ...response,
          items,
        });
      }),
    );
  }

  public search(search: string): Observable<Story[]> {
    return this.httpClient.get(
      `${environment.apiUrl}/api/stories`,
      {
        params: {
          search,
          pageSize: 50_000,
        },
      },
    ).pipe(
      map((response: any): Story[] => {
        return response.items
          .map((response: any): Story => Story.createFromApi(response));
      }),
    );
  }

  public getStoryById(storyId: string): Observable<Story> {
    return this.httpClient.get(`${environment.apiUrl}/api/stories/${storyId}`)
      .pipe(
        map((response: any): Story => Story.createFromApi(response)),
      );
  }

  public createStory(story: Story, publish: boolean): Observable<{ id: string }> {
    return this.httpClient.post<{ id: string }>(
      `${environment.apiUrl}/api/stories`,
      story.processForApi(publish),
    );
  }

  public updateStory(story: Story, publish: boolean): Observable<void> {
    return this.httpClient.put<void>(
      `${environment.apiUrl}/api/stories/${story.id}`,
      story.processForApi(publish),
    );
  }

  public deleteStory(storyId: string): Observable<void> {
    return this.httpClient.delete<void>(`${environment.apiUrl}/api/stories/${storyId}`);
  }

  public importStories(csvFileFormData: FormData): Observable<void> {
    return this.httpClient.post<void>(`${environment.apiUrl}/api/stories/import`, csvFileFormData);
  }

}
